import { useEffect, useState } from "react";
import { changeUserStatus, changeUserStatusDisable } from "../../apis";
import Snackbar from "../Snackbar";
import { makeStyles } from "@material-ui/core";
import useToken from '../../hooks/useToken';
import { getcreateAuditlog } from '../../apis';

export const ToggleBtn = ({ data,onStatusChange,
  active: activeProp,
  onChange,
  activeColor = "green",
  inactiveColor = "red"
}) => {
  const { getCurrentUserDetails } = useToken();
  // Track/thumb geometry matches globalStyles.js's calBlockToggleTrack/calBlockToggleThumb.
  const useStyles = makeStyles(() => ({
    switchInput: {
      opacity: 0,
      width: 0,
      height: 0,
    },
    toggleTrack: {
      width: 36,
      height: 20,
      borderRadius: 10,
      border: "none",
      padding: 0,
      position: "relative",
      cursor: "pointer",
      flexShrink: 0,
      transition: "background 0.2s ease",
    },
    toggleThumb: {
      position: "absolute",
      top: 2,
      left: 2,
      width: 16,
      height: 16,
      borderRadius: "50%",
      background: "white",
      boxShadow: "0 1px 2px rgba(0,0,0,0.3)",
      transition: "left 0.2s ease",
    },
    toggleThumbOn: {
      left: 18,
    },
  }));

  const snackInitial = { open: false, message: "", severity: "" };
  const [snack, setSnack] = useState(snackInitial);
  const [active, setActive] = useState(data ? data.active : activeProp);
  const classes = useStyles();

  useEffect(() => {
    if (data) setActive(data.active);
    else if (activeProp !== undefined) setActive(activeProp);
  }, [data, activeProp]);

async function changeActive() {
  setActive(!active);
  if (data) {
    try {
      const currentUser = getCurrentUserDetails();
      const auditPayload = [];
      if (active) {
        await changeUserStatusDisable(data.email_id);
        auditPayload.push({
          parentId: data.email_id,
          field: 'status',
          oldValue: 'Active',
          newValue: 'Disabled',
          createdBy: currentUser.name,
        });
      } else {
        await changeUserStatus(data.email_id);
        auditPayload.push({
          parentId: data.email_id,
          field: 'status',
          oldValue: 'Disabled',
          newValue: 'Active',
          createdBy: currentUser.name,
        });
      }
      await getcreateAuditlog(auditPayload);

      if (onStatusChange) {
        onStatusChange();
      }
    } catch (err) {
      setSnack({
        open: true,
        severity: "error",
        message: err,
      });
      setActive(active);
    }
  }
  else if (onChange) {
    onChange(!active);
  }
}
  return (
    <>
      <div
        role="switch"
        aria-checked={active}
        className={classes.toggleTrack}
        style={{ backgroundColor: active ? activeColor : inactiveColor }}
        onClick={changeActive}
      >
        <input type="checkbox" className={classes.switchInput} checked={active} readOnly />
        <div className={`${classes.toggleThumb} ${active ? classes.toggleThumbOn : ""}`} />
      </div>

      {snack.open && (
        <Snackbar
          {...snack}
          handleClose={() => setSnack(snackInitial)}
        />
      )}
    </>
  );
};
